import React, { useRef, useState } from 'react';
import { SearchbarInput } from './searchHeaderStyles';
import { useHistory } from 'react-router';
import { arrowForwardCircle } from 'ionicons/icons';

const Searchbar: React.FC = () => {
	const [result, setResult] = useState('');
	const latestQueryRef = useRef('');
	const history = useHistory();

	const submitSearch = (rawQuery: string) => {
		const query = rawQuery.trim().toLowerCase();
		if (!query) {
			return;
		}
		history.push(`/search-results?q=${encodeURIComponent(query)}`);
	};

	const updateQuery = (rawQuery: string) => {
		const query = rawQuery.toLowerCase();
		latestQueryRef.current = query;
		setResult(query);
	};

	const handleChange = (ev: CustomEvent) => {
		const target = ev.target as HTMLIonSearchbarElement | null;
		updateQuery(String(target?.value ?? ''));
	};

	const handleBlur = () => {
		latestQueryRef.current = '';
		setResult('');
	};

	const handleKeyDown = (ev: React.KeyboardEvent<HTMLIonSearchbarElement>) => {
		if (ev.key === 'Enter') {
			const target = ev.target as HTMLIonSearchbarElement | null;
			submitSearch(String(target?.value ?? latestQueryRef.current));
		}
	};

	return (
		<>
			<SearchbarInput
				clearIcon={arrowForwardCircle}
				enterkeyhint="search"
				onBlur={handleBlur}
				placeholder="Looking for something?"
				onIonChange={(e) => {
					handleChange(e);
				}}
				onKeyDown={handleKeyDown}
				onIonClear={() => submitSearch(latestQueryRef.current)}
				value={result}
				debounce={500}
			/>
		</>
	);
};

export default Searchbar;
